module.exports = __webpack_public_path__ + "static/media/gt-infra-trade.41ed1be1.png";